/**
 * @generated SignedSource<<dcd001914ce258ec3036c0b5d346bf2f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ClearUserPushTokensInput = {
  clientMutationId?: string | null | undefined;
};
export type useClearUserPushTokensMutation$variables = {
  input: ClearUserPushTokensInput;
};
export type useClearUserPushTokensMutation$data = {
  readonly clearUserPushTokens: {
    readonly user: {
      readonly isPushNotificationsEnabled: boolean | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useClearUserPushTokensMutation = {
  response: useClearUserPushTokensMutation$data;
  variables: useClearUserPushTokensMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPushNotificationsEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useClearUserPushTokensMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ClearUserPushTokensPayload",
        "kind": "LinkedField",
        "name": "clearUserPushTokens",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useClearUserPushTokensMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ClearUserPushTokensPayload",
        "kind": "LinkedField",
        "name": "clearUserPushTokens",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "874ec2fd693ccc6f48cf77b776f9515b",
    "id": null,
    "metadata": {},
    "name": "useClearUserPushTokensMutation",
    "operationKind": "mutation",
    "text": "mutation useClearUserPushTokensMutation(\n  $input: ClearUserPushTokensInput!\n) {\n  clearUserPushTokens(input: $input) {\n    user {\n      isPushNotificationsEnabled\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d78fe6d55822183992ccf1efa8debe26";

export default node;
